import { hot } from 'react-hot-loader/root';
import Component from './organisationsList-redux';

export default hot(Component);
